import { schema } from 'normalizr';

const browseSchema = new schema.Entity('filteredUsers');

export default browseSchema;
